(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["geo-redirect-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const BOT_RE = /bot|crawl|spider|slurp|Googlebot|Bingbot|Yandex|Baidu|DuckDuckBot|facebookexternalhit|Twitterbot|LinkedInBot|Applebot|AhrefsBot|SemrushBot|MJ12bot|PetalBot/i;
    if (BOT_RE.test(navigator.userAgent)) return;

    if (document.querySelector('.shopify-challenge__container')) return;

    const STORAGE_KEY = 'geo-redirect-dismissed';
    const DISMISS_MS = 72 * 60 * 60 * 1000;

    const isDismissed = () => {
      try {
        const ts = localStorage.getItem(STORAGE_KEY);
        if (!ts) return false;
        return (Date.now() - parseInt(ts, 10)) < DISMISS_MS;
      } catch {
        return false;
      }
    };

    const setDismissed = () => {
      try {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
      } catch { /* noop */ }
    };

    if (isDismissed()) return;

    const cfg = window.__geoRedirectConfig;
    if (!cfg?.currentRegion || !cfg?.storeUrls) return;

    const { storeUrls, currentRegion } = cfg;
    if (!Object.values(storeUrls).some(Boolean)) return;

    const EU_COUNTRIES = [
      'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR',
      'DE','GR','HU','IE','IT','LV','LT','LU','MT','NL',
      'PL','PT','RO','SK','SI','ES','SE'
    ];

    const REGION_NAMES = {
      US: 'United States',
      CA: 'Canada',
      GB: 'United Kingdom',
      EU: 'European',
      AU: 'Australian'
    };

    const REGION_SHORT = {
      US: 'US',
      CA: 'Canadian',
      GB: 'UK',
      EU: 'EU',
      AU: 'AU'
    };

    const COUNTRY_NAMES = {
      US: 'the United States', CA: 'Canada', GB: 'the United Kingdom',
      AU: 'Australia', NZ: 'New Zealand',
      AT: 'Austria', BE: 'Belgium', BG: 'Bulgaria', HR: 'Croatia',
      CY: 'Cyprus', CZ: 'Czech Republic', DK: 'Denmark', EE: 'Estonia',
      FI: 'Finland', FR: 'France', DE: 'Germany', GR: 'Greece',
      HU: 'Hungary', IE: 'Ireland', IT: 'Italy', LV: 'Latvia',
      LT: 'Lithuania', LU: 'Luxembourg', MT: 'Malta', NL: 'Netherlands',
      PL: 'Poland', PT: 'Portugal', RO: 'Romania', SK: 'Slovakia',
      SI: 'Slovenia', ES: 'Spain', SE: 'Sweden'
    };

    const countryToRegion = (cc) => {
      if (cc === 'US') return 'US';
      if (cc === 'CA') return 'CA';
      if (cc === 'GB') return 'GB';
      if (cc === 'AU' || cc === 'NZ') return 'AU';
      if (EU_COUNTRIES.includes(cc)) return 'EU';
      return null;
    };

    const showBanner = (countryCode, region) => {
      const url = storeUrls[region];
      if (!url) return;

      const banner = document.getElementById('geo-redirect-banner');
      const overlay = document.getElementById('geo-redirect-overlay');
      if (!banner) return;

      const regionName = REGION_NAMES[region] ?? region;
      const regionShort = REGION_SHORT[region] ?? region;

      document.getElementById('geo-banner-region').textContent = COUNTRY_NAMES[countryCode] ?? countryCode;
      document.getElementById('geo-banner-region-store').textContent = regionShort;
      document.getElementById('geo-banner-btn-region').textContent = regionShort;
      document.getElementById('geo-banner-link').href = url;

      banner.classList.add('geo-banner--visible');
      if (overlay) overlay.classList.add('geo-banner--visible');
    };

    const hideBanner = () => {
      const banner = document.getElementById('geo-redirect-banner');
      const overlay = document.getElementById('geo-redirect-overlay');
      if (!banner) return;

      banner.classList.remove('geo-banner--visible');
      if (overlay) overlay.classList.remove('geo-banner--visible');
      setDismissed();
    };

    document.getElementById('geo-banner-close')?.addEventListener('click', (e) => {
      e.preventDefault();
      hideBanner();
    });

    document.getElementById('geo-banner-stay')?.addEventListener('click', (e) => {
      e.preventDefault();
      hideBanner();
    });

    document.getElementById('geo-redirect-overlay')?.addEventListener('click', () => {
      hideBanner();
    });

    fetch('https://ipapi.co/json/')
      .then((res) => {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then((data) => {
        const cc = data?.country_code;
        if (!cc) return;

        const region = countryToRegion(cc);
        if (!region || region === currentRegion) return;

        showBanner(cc, region);
      })
      .catch(() => {});
  })();
  } catch(e) { console.error(e); }
})();

})();
